import apiFetch from '../../apiFetch'

export default function (saleId, dossierSaleUacIncome, token, lastAccessDate, vehicleId) {
  let vehicleParam = ''
  if (vehicleId) {
    vehicleParam = `&vehicleId=${vehicleId}`
  }
  return apiFetch({ endPoint: `dossier/purchase/UAC?saleId=${saleId}${vehicleParam}`, method: 'POST', body: dossierSaleUacIncome, token: token, lastAccessDate })
}
